import { IGetPaymentManifestRequest, GetPaymentManifest } from '../contracts';
import axios from 'axios';
import { createAxiosConfig } from '../mockHelper';

export const GetPaymentManifestApi =
  (endpoint: string): GetPaymentManifest =>
  async (request: IGetPaymentManifestRequest) => {
    try {
      const response = await axios.post(endpoint, request, createAxiosConfig(null, endpoint));
      return Promise.resolve(response?.data);
    } catch (e) {
      return Promise.reject({ error: e });
    }
  };
